import { NavbarSearchDesktop } from "./navbar-search-desktop";
import { NavbarSearchMobile } from "./navbar-search-mobile";
import { NavbarSearchTablet } from "./navbar-search-tablet";
import styles from "./navbar-search.module.css";

export function NavbarSearch() {
  return (
    <div className={styles.Container}>
      <NavbarSearchDesktop />
      <NavbarSearchMobile />
      <NavbarSearchTablet />
    </div>
  );
}
